import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import { caseDetailsProps } from "../../../../services/typedefine";
import { GET_ATTACHMENT_FILE_DOWNLOAD } from "../../../../services";
import { apiGetFileDownloadSiteAccount, apiGetWithHeader } from "../../../../services/service";
import "./case-details.scss";
import { Trans, useTranslation } from "react-i18next";
const CaseDetails: React.FC<caseDetailsProps> = ({ caseDetails, attachedFilesData }) => {

  const downloadAttachmentHandler = async (key: any,fileName:string) => {
    try {
      const response = await apiGetFileDownloadSiteAccount(GET_ATTACHMENT_FILE_DOWNLOAD + key);
      if (response.data) {
      if (response.status === 200) {
        let filename = fileName;
        var success = false;
        if (!success) {
          let urlCreator = window.URL || window.webkitURL;
          if (urlCreator) {
            let link = document.createElement("a");
            if ("download" in link) {
              try {
                const buffer = response.data;
                let blob = new Blob([buffer], {
                  type: "application/octet-stream",
                });
                let url = urlCreator.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                let event = document.createEvent("MouseEvents");
                event.initMouseEvent(
                  "click",
                  true,
                  true,
                  window,
                  1,
                  0,
                  0,
                  0,
                  0,
                  false,
                  false,
                  false,
                  false,
                  0,
                  null
                );
                link.dispatchEvent(event);

                success = true;
              } catch (ex) {
                console.log(ex);
              }
            }
          }
        }
      }
      }
    } catch (error) {
      console.error("Error fetching recent cases:", error);
    }
  };
  const {t} = useTranslation();

  return (
    <div className="case-details">
      <Container className="container-custom">
        <Col md={12} className="container-row">
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Casetitle",{defaultValue:'Case title:'})}</Col>
            <Col md={8}>{caseDetails.CaseTitle}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.OS/version",{defaultValue:'OS/version:'})}</Col>
            <Col md={8}>{caseDetails.OperatingSystemVersion}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Productname",{defaultValue:'Product name:'})}</Col>
            <Col md={8}>{caseDetails.ProdName}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Serialnumber",{defaultValue:'Serial number:'})}</Col>
            <Col md={8}>{caseDetails.SerialNm}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Customertrackingnumber",{defaultValue:'Customer tracking number:'})}</Col>
            <Col md={8}>{caseDetails.CustomerTracking}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Casetype",{defaultValue:'Case type:'})}</Col>
            <Col md={8}>{caseDetails.ProblemType}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Caseresolutioncode",{defaultValue:'Case resolution code:'})}</Col>
            <Col md={8}>{caseDetails.CaseResolutionCode}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.CreateCase.ErrorCodes",{defaultValue:'Error code:'})}</Col>
            <Col md={8}>{caseDetails.ErrorCodes}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Problemdescription",{defaultValue:'Problem description:'})}</Col>
            {caseDetails?.ProblemDesc ?  <Col md={8} dangerouslySetInnerHTML={{ __html: caseDetails?.ProblemDesc.replace(/\n/g, '<br />') }} /> : ''}
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.Troubleshootingsteps",{defaultValue:'Troubleshooting steps:'})}</Col>
            <Col md={8}>{caseDetails.TroubleShooting}</Col>
          </Row>
          <Row>
            <Col md={3}>{t("HPI.EditCase.Casedetails.PINNumber",{defaultValue:'PIN number:'})}</Col>
            <Col md={8}>{caseDetails.PinNumber}</Col>
          </Row>
          {Number(attachedFilesData?.Item2?.trim()) > 0 ? (
            <Row>
              <Col md={3}>Attachments:</Col>
              <Col md={8}>
                {attachedFilesData?.Item3?.filter((val:{Key: string, Value: string})=> 
                !val?.Value?.includes("Federator"))?.map((val: any, index: number) => (
                  <a
                    key={index}
                    className="anchor-container"
                    onClick={() => downloadAttachmentHandler(val.Key,val.Value)}
                  >
                    {val.Value}
                  </a>
                ))}
              </Col>
            </Row>
          ) : null}
        </Col>
      </Container>
    </div>
  );
};

export default CaseDetails;
